module.exports = __webpack_public_path__ + "img/侯瑞鹤.2fc2ee96.png";